import moment from 'moment';

const dateHelper = {};

dateHelper.isInvalidPeriod = (date1, date2) => moment(date1).isAfter(date2);

dateHelper.subtractDays = (date, interval) => moment(date).subtract(interval, 'days').toDate();

dateHelper.truncate = date => moment.utc(date).startOf('day').format();

dateHelper.today = () => dateHelper.truncate(new Date());

dateHelper.formatedDate = (date, format, formatUTC = false) => {
  let adjustedDate = moment(date);
  adjustedDate = formatUTC ? adjustedDate.utc() : adjustedDate.local();
  return adjustedDate.format(format);
};

dateHelper.todayFormated = format => dateHelper.formatedDate(dateHelper.today(), format);

export default dateHelper;



// WEBPACK FOOTER //
// ./src/services/date/index.js